// Rivales tentativos de la llave para la Timba: cascada de equipos a partir de los pronósticos
// del jugador (quién hace avanzar) + resultados reales. Reusa el resolutor del simulador.
import { BracketStage, TeamRef, TimbaPrediction } from '../api/client';
import { buildGraph, createResolver } from './simulate';
import { BracketPicks } from '../stores/store';
import { predAdvancer } from './timba';

export interface SlotDisp {
  team: string | null; // selección que ocupa el slot (real, proyectada o tentativa), o null
  label: string; // texto si no hay equipo ("Ganador del #74", "1º Grupo J", ...)
  confirmed: boolean; // true = equipo ya confirmado (no tentativo)
}

type Preds = Record<number, TimbaPrediction>;

// Picks (nombre del ganador) derivados de los pronósticos, en orden de ronda para que cada
// cruce conozca a sus alimentadores antes de resolverse.
function picksFromPreds(stages: BracketStage[], preds: Preds): BracketPicks {
  const g = buildGraph(stages);
  const picks: BracketPicks = {};
  for (const m of stages.flatMap((s) => s.matches)) {
    if (m.num == null || !preds[m.num]) continue;
    const [s1, s2] = createResolver(g, picks).parts(m);
    const adv = predAdvancer(preds[m.num]);
    const team = adv === 1 ? s1.team : adv === 2 ? s2.team : null;
    if (team) picks[m.num] = team;
  }
  return picks;
}

// Por cada nº de partido, los dos equipos a mostrar y si están confirmados (vs tentativos).
export function timbaBracketSlots(stages: BracketStage[], preds: Preds): Map<number, [SlotDisp, SlotDisp]> {
  const g = buildGraph(stages);
  const disp = createResolver(g, picksFromPreds(stages, preds)); // con picks del usuario
  const real = createResolver(g, {}); // solo resultados reales → para detectar "confirmado"

  const slot = (ref: TeamRef): SlotDisp => {
    const w = /^W(\d+)$/.exec(ref.name);
    if (w) return { team: disp.winner(+w[1]), label: `Ganador del #${w[1]}`, confirmed: real.winner(+w[1]) !== null };
    const l = /^L(\d+)$/.exec(ref.name);
    if (l) return { team: disp.loser(+l[1]), label: `Perdedor del #${l[1]}`, confirmed: real.winner(+l[1]) !== null };
    return { team: ref.resolved, label: ref.label ?? ref.name, confirmed: ref.resolved !== null && !ref.projected };
  };

  const out = new Map<number, [SlotDisp, SlotDisp]>();
  for (const m of g.matches) {
    if (m.num != null) out.set(m.num, [slot(m.team1), slot(m.team2)]);
  }
  return out;
}
